import React from 'react';

const TweetStorm = () => {
  return (
    <div className="tweetStorm">
      <div className="tweetStormText">
        <p className="tweetStormTextMain">
          <span className="blue-bottom">Stop</span> losing your favorite tweets, and <span className="blue-bottom">manage</span> them
          with <span className="blue-bottom">ease</span>.
        </p>
      </div>

      <img id="tweetStormImg" src={require('../../assets/tweetstorm.svg')} alt="tweets in box" />
    </div>
  );
};

export default TweetStorm;